export {InputTag as InputTagStandalone} from './input-tag';
export {Tag as TagStandalone} from './tag';
export {TagEditable as TagEditableStandalone} from './tag-editable';
export {InputTagConnected as InputTag} from './input-tag-connected';
export {TagConnected as Tag} from './tag-connected';
export {TagEditableConnected as TagEditable} from './tag-editable-connected';
export {useInputTagContext, InputTagContext} from './input-tag-context';
export {useInputTagState} from './use-input-tag-state';
